export default __webpack_public_path__ + "static/artboard--landing-064f775a93afae9c125482ce753c14d6.jpg";